module.exports = __webpack_public_path__ + "img/gb9117_8_d.prt.2b42a304.jpg";